module.exports = __webpack_public_path__ + "img/moreSolidIcon.b4a574ea.svg";